










































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AccountManager, Account } from '@/models'
import { Utils } from '@/utils'

@Component({
  components: {}
})
export default class AccountWorkers extends Vue {
  @Prop({ required: true }) workers!: AccountManager[]
  @Prop({ required: true }) currentAccountId!: string

  private selectedManagerIds: string[] = []
  private availableManagers: Account[] = []
  private addingWorker = false
  private managerSearchLength = 0
  private searchFilter = ''
  private workersCurrentPage = 1
  private workersPerPage = 10

  private workersFields = [
    {
      key: 'accountId',
      label: this.$t('account_detail.workers.columns.account_id'),
      sortable: true
    },
    {
      key: 'createdOn',
      label: this.$t('account_detail.workers.columns.created_on'),
      sortable: true
    },
    {
      key: 'actions',
      label: this.$t('table.actions'),
      sortable: false,
      class: 'text-center'
    }
  ]

  get hasSearchFilter(): boolean {
    return this.searchFilter.trim() !== ''
  }

  get filteredWorkers(): AccountManager[] {
    if (!this.hasSearchFilter) return this.workers
    const filterNormalized = Utils.normalizeText(this.searchFilter)
    return this.workers.filter(worker => {
      const accountIdNormalized = Utils.normalizeText(worker.accountId)
      return accountIdNormalized.includes(filterNormalized)
    })
  }

  get workersPaginated(): AccountManager[] {
    const start = (this.workersCurrentPage - 1) * this.workersPerPage
    const end = start + this.workersPerPage
    return this.filteredWorkers.slice(start, end)
  }

  @Watch('searchFilter')
  onSearchFilterChange() {
    this.workersCurrentPage = 1
  }

  handleSearch(search: string, loading: (value: boolean) => void) {
    this.managerSearchLength = search ? search.length : 0
    this.$emit('search-managers', {
      search,
      loading,
      setResults: (results: Account[]) => { this.availableManagers = results },
      setSearchLength: (length: number) => { this.managerSearchLength = length }
    })
  }

  handleAddWorkers() {
    this.$emit('add-workers', {
      selectedManagerIds: this.selectedManagerIds,
      setAdding: (value: boolean) => { this.addingWorker = value },
      clearSelection: () => {
        this.selectedManagerIds = []
        this.availableManagers = []
      }
    })
  }

  handleDeleteWorker(accountManager: AccountManager) {
    this.$emit('delete-worker', accountManager)
  }

  handleDeleteAllWorkers() {
    this.$emit('delete-all-workers')
  }

  goToAccountDetail(accountId: string) {
    this.$router.push({ name: 'AccountDetail', params: { accountId } })
  }

  getSelectedAccounts(): Account[] {
    return this.availableManagers.filter(account =>
      this.selectedManagerIds.includes(account.accountId)
    )
  }

  public setAvailableManagers(managers: Account[]) {
    this.availableManagers = managers
  }
}
